import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { normalizeLocale } from "../routeLocale";
import { useProductContext } from "./ProductContextProvider";
import { traceAgentLanguageSwitchDisabled } from "../routeTelemetry";
import { resolveUiDirectionFromLocale, setUiDirection } from "../uiDirection";

/**
 * URL locale owns document direction. i18next stays Hebrew (supportedLngs: he)
 * so we do not call changeLanguage('en'|'el') — that falls back to he and used
 * to overwrite dir back to rtl.
 */
export function RouteLocaleSync() {
  const { locale } = useProductContext();
  const routeLng = normalizeLocale(locale);

  useEffect(() => {
    if (!routeLng) return;
    setUiDirection(resolveUiDirectionFromLocale(routeLng));
  }, [routeLng]);

  return null;
}

/**
 * DEV trace: agent dashboard has no in-app language switcher.
 */
export function AgentDashboardLocalePolicy() {
  const location = useLocation();

  useEffect(() => {
    traceAgentLanguageSwitchDisabled({
      path: location.pathname,
      reason: "agent_dashboard_language_switch_removed",
    });
  }, [location.pathname]);

  return null;
}

export default RouteLocaleSync;
